import { BarChartOutlined, CheckCircleOutlined, DollarOutlined, FileTextOutlined } from '@ant-design/icons'

const HIGHLIGHTS = [
  {
    icon: <DollarOutlined />,
    title: 'Value that grows with you',
    description: 'Tiered pricing that gets cheaper per connection as you scale.',
  },
  {
    icon: <BarChartOutlined />,
    title: 'AI Analysis & Review',
    description:
      'Nine findings ranked by materiality, with talking points and recommendations, ready before the meeting.',
  },
  {
    icon: <FileTextOutlined />,
    title: 'Client-ready outputs in minutes',
    description: 'Branded Full Advisory Report, Executive Summary, Slide deck, and Pre-meeting email.',
  },
  {
    icon: <CheckCircleOutlined />,
    title: 'Xero-native',
    description: 'Pulls P&L, Cash Flow, Balance Sheet, Aged Receivables and Payables daily. Read-only, secure.',
  },
]

export default function AdvicePrepHighlights() {
  return (
    <div className="mt-[2rem] flex flex-col gap-[0.875rem]">
      {HIGHLIGHTS.map((item) => (
        <div key={item.title} className="flex items-start gap-[0.875rem]">
          <div className="grid h-[2.375rem] w-[2.375rem] shrink-0 place-items-center rounded-[0.625rem] bg-brand-500/[0.15] text-[1.125rem] text-brand-700">
            {item.icon}
          </div>
          <div className="min-w-0">
            <strong className="block text-[0.9375rem] font-semibold text-gray-900">{item.title}</strong>
            <span className="text-[0.84375rem] leading-[1.5] text-gray-600">{item.description}</span>
          </div>
        </div>
      ))}
    </div>
  )
}
